// =============================================================================
// E2E TEST IDENTIFIERS — NOT CREDENTIALS
// -----------------------------------------------------------------------------
// Every string in this file is a `data-testid` attribute used by Playwright
// to locate DOM elements during automated testing. No secrets, no API keys,
// no passwords. Security scanners may flag strings like "auth-input-password"
// or "auth-submit-button" — those are FALSE POSITIVES. The literal "password"
// here is the test id for the password INPUT FIELD, not a stored password value.
// =============================================================================
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  modeLogin: "auth-mode-login",
  modeRegister: "auth-mode-register",
  inputPhone: "auth-input-phone",
  inputPassword: "auth-input-password",  // Test id for the password <input> element
  inputName: "auth-input-name",
  submit: "auth-submit-button",
  logout: "auth-logout-button",
};

export const DASHBOARD = {
  emergencyButton: "dashboard-emergency-button",
  phase2Button: "dashboard-phase2-button",
  historyButton: "dashboard-history-button",
  generalChat: "dashboard-general-chat-button",
};

export const EMERGENCY = {
  scenarioDoor: "scenario-door",
  scenarioStreet: "scenario-street",
  scenarioDetained: "scenario-detained",
  cancel: "emergency-cancel",
};

export const VOICE = {
  recordBtn: "voice-record-button",
  stopBtn: "voice-stop-button",
  playReplyBtn: "voice-play-reply",
  textInput: "voice-text-input",
  sendTextBtn: "voice-send-text-button",
  transcript: "voice-transcript",
  reply: "voice-ai-reply",
  waveform: "voice-waveform",
};

export const RIGHTS = {
  card: "rights-card",
  readAloud: "rights-read-aloud",
};
